module.exports = __webpack_public_path__ + "img/avec_donees_modifier.d93c0e7a.png";